import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {kitsUpdateLocationTableReady,rowsPerPageState,searchTextState,paginationState} from '../redux/kits'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/productKits.css'
//import * as Helpers from '../../../common/helpers'


function filterUnwantedData(locationData) {
    let array = []
    if (locationData && locationData.data && locationData.data.List) {
        array = locationData.data.List
    }

    let newArray = []
    let noStoreArray = []
    let storeArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let lineData = array[i]
            
           if(lineData.store_kits.length>0){
                lineData.existing=1
                lineData.checked=true
                lineData.quantity=lineData.store_kits[0].quantity
                lineData.estimated_cost=lineData.store_kits[0].estimated_cost
                lineData.store_kit_id=lineData.store_kits[0].store_kit_id
                storeArray.push(lineData)
           }else{
                lineData.checked=false
                lineData.existing=0
                lineData.quantity=0
                lineData.estimated_cost=0
                lineData.store_kit_id=0
                noStoreArray.push(lineData)
           }

        
        }
    }
    newArray=storeArray.concat(noStoreArray)
    return newArray
}


class KitsStoresUpdateLocationTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            productLocationData: [],
            productSelected:{},
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(kitsUpdateLocationTableReady(false))

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getStoreLocationData()        
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getStoreLocationData = () => {



         if(this.props.kits && this.props.kits.productSelected && this.props.kits.productSelected !== null){
            this.props.dispatch(headerDataUpdate(Constants.KITS_STORES_UPDATE_LOCATION))
            this.props.dispatch(subHeaderDataUpdate(" - "+this.props.kits.productSelected.sku_name))

            let prevProductData= this.props.kits.productSelected                
                        this.setState({
                            productSelected:prevProductData
                        })

        apiService.listMarkedProductSelling(this.props.kits.productSelected.id)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.kits && this.props.kits.previousPaginationValue) {
                            pageNo = this.props.kits.previousPaginationValue
                        }
                        this.setState({
                            productLocationData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(kitsUpdateLocationTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(kitsUpdateLocationTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })

        }
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.kits && this.props.kits.previousRowsPerPageValue) {
            value = this.props.kits.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   
                   <div className="col-xs-12 col-sm-12 col-md-10 header-div-margins">
                            <a href="" 
                                onClick={(e) => {e.preventDefault() 
                                            this.props.history.goBack()}}> 
                                    <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                            </a>
                    </div>

                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.updateLocation()
                            }}>
                            Update Location
                        </button>
                    </div>

                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return (
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 footer-pagination-icons">
                    {props.components.pageList}
                </div>
            </div>
        )
    }

    getFilteredBrandList = () => {
       
        this.props.dispatch(kitsUpdateLocationTableReady(false))
        this.resetSearchAndPagination()
        this.getStoreLocationData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getStoreLocationData()
        this.props.dispatch(kitsUpdateLocationTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }

    updateLocation = () => {

         this.props.dispatch(kitsUpdateLocationTableReady(false))

    let prodLocationData=this.state.productLocationData.slice();
    let added=[]
    let removed=[]
        prodLocationData.map(function(item) {
            if(item.checked && item.existing===0){
                let obj={"store_id":item.store_id}
                added.push(obj)
            }else if(item.existing===1 && !item.checked){
                let obj={"store_kit_id":item.store_kits[0].store_kit_id}
                removed.push(obj)
            }   
            return true
        })

        let apiPayloadData={
            "product_stores_list":{
                added,
                removed
                }}

        apiService.postStoresKitsUpdate(apiPayloadData,this.state.productSelected.id)
            .then(responseData => {
                 this.props.dispatch(kitsUpdateLocationTableReady(true))
                    if (responseData.status === "SUCCESS") {
                        window.location.reload()
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                console.error("Error data: ", err)
               alert("exception");
            })

            return true
        
    }


    // checkBoxUpdate = (row) => {
    //     let prodLocationData=this.state.productLocationData.slice();
    //         if(row.checked){

    //                 if(row.existing==1){    
    //                     this.state.storesRemoved.push(row.store_id)
    //                 }else{
    //                     const index = this.state.storesAdded.indexOf(row.store_id);
    //                     if (index > -1) {
    //                       this.state.storesAdded.splice(index, 1); // 2nd parameter means remove one item only
    //                     }
    //                 }   

    //                 prodLocationData.map(function(item) {
    //                         if(item.store_id==row.store_id){
    //                             item.checked=false;
    //                             return true;
    //                         }
    //                     });
    //                 this.setState({
    //             productLocationData: prodLocationData
    //         })

    //         }else{ 

    //             if(row.existing==0){
    //                 this.state.storesAdded.push(row.store_id)
                   
    //             }else{
    //                  const index = this.state.storesRemoved.indexOf(row.store_id);
    //                     if (index > -1) {
    //                         this.state.storesRemoved.splice(index, 1); // 2nd parameter means remove one item only
    //                     }
    //             }                

    //              prodLocationData.map(function(item) {
    //                     if(item.store_id==row.store_id){
    //                         item.checked=false;
    //                         return true;
    //                     }
    //             });

    //              this.setState({
    //             productLocationData: prodLocationData
    //         })

    //         }  
        
    // }


       checkBoxChange = (row,e,rowIndex) => {

        let prodLocationData=this.state.productLocationData.slice();
           
             prodLocationData.map(function(item) {
                if(item.store_id===row.store_id){
                    item['checked']=e.target.checked
                    return true;
                }
                return true
            });

             this.setState({
                productLocationData:prodLocationData
             })
        }
        

    renderCheckBox = (cell, row, enumObject, rowIndex) => {
        //debugger;
        let checkBox=<input className="checkbox" type="checkbox" value={row.store_id} onChange={(e) => {
                     this.checkBoxChange(row,e,rowIndex)
                }} checked={row.checked}/>
        
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{checkBox}</div>
        </div>)
    }


    

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.kits && this.props.kits.previousPaginationValue
            && this.props.kits.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editBrand = (row) => {
        // if (row && row.id) {
        //     this.props.dispatch(brandIdForAction(row.id))
        //     this.props.history.push("/dashboard/brand/addedit")
        // } else {
        //     this.dialog.show({
        //         title: "Brand Identification number not found",
        //         body: 'Brand id is not available, So not able edit brand',
        //         actions: [
        //             Dialog.OKAction(() => {
        //             })
        //         ],
        //     })
        // }
    }

    render() {
        let sizeperPage = 15

        if (this.props.kits && this.props.kits.previousRowsPerPageValue) {
            sizeperPage = this.props.kits.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (

            <div className="product-location-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                        
                <Dialog ref={el => this.dialog = el} />
                    <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.productLocationData}
                    pagination={false}
                    hover={true}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}
                   >
                    <TableHeaderColumn
                        dataField="store_id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Id
                    </TableHeaderColumn>
                      <TableHeaderColumn
                        dataFormat={this.renderCheckBox}
                        dataAlign='center'
                        width="50"
                        tdStyle={{ whiteSpace: 'normal' }}>
                        
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="store_name"
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Store Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="kitchen_name"
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Kitchen Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="brand_name"
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Brand Name
                    </TableHeaderColumn>

                </BootstrapTable>

            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        kits: state.kits
    }
}

export default connect(mapStateToProps)(withRouter(KitsStoresUpdateLocationTable))


// WEBPACK FOOTER //
// ./src/modules/Kits/Components/KitsStoresUpdateLocationTable.js